import styled from 'styled-components';
import {
  openDetailLink,
  openKakaoLink,
  openYoutubeLink,
  openAppDownloadLink,
  isWeb,
} from '../../../utils';
import { ImageUtils } from '../../../utils/ImageUtils';
import { useTextVariant } from '../../../hook/useTextVariant';
import { BOTTOM_SNS_CONSTANTS } from '../../../constants/bottomSns';

export const BottomSnsMobile = () => {
  const { getText } = useTextVariant(BOTTOM_SNS_CONSTANTS, true);

  const links = [
    {
      icon: ImageUtils.SnsIcon1,
      text: getText('appDownload'),
      onClick: openAppDownloadLink,
      onlyWeb: true,
    },
    { icon: ImageUtils.SnsIcon2, text: getText('kakaoChannel'), onClick: openKakaoLink },
    { icon: ImageUtils.SnsIcon3, text: getText('youtube'), onClick: openYoutubeLink },
    { icon: ImageUtils.SnsIcon4, text: getText('detail'), onClick: openDetailLink },
  ];

  return (
    <Container>
      <Inner>
        {links.map((link, index) => {
          if (!isWeb() && link.onlyWeb) {
            return null;
          }
          return (
            <Link key={index} onClick={link.onClick}>
              <img src={link.icon} alt="" />
              <LinkText>{link.text}</LinkText>
            </Link>
          );
        })}
      </Inner>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 10;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 98px;
`;

const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: 37px;
  padding-right: 37px;
  height: 98px;
  background: rgba(64, 64, 64, 0.5);
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.1);
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  backdrop-filter: blur(25px);
  -webkit-backdrop-filter: blur(25px);
`;

const Link = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0;
  white-space: pre-wrap;

  &:last-child {
    margin-right: 0;
  }

  img {
    width: 24px;
    margin-bottom: 6px;
  }
`;

const LinkText = styled.h4`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  letter-spacing: -0.04em;
  color: rgba(255, 255, 255, 0.8);
`;
